import {Route} from "react-router-dom";
import LaunchpadMainFragment from "../../layout/LaunchpadMainFragment.jsx";
import Dashboard from "../Dashboard.jsx";
import Home from "../Home.jsx";


function RoutePath(path, component, title, exact = false, isPrivate = false) {
	  return {path, component, title, exact, isPrivate};
}


export const HOME = new RoutePath("/", Home, "Home", true);
export const DASHBOARD = new RoutePath("/dashboard", Dashboard, "Dashboard", true);


export const webappName = "APXLaunchpad";

export const webappPaths = {
	  root: "/"
};
export const webappRoutes = [
	  <Route path={webappPaths.root} exact component={LaunchpadMainFragment}/>
];